/**
 * A page header for topics, such as subjects and units.
 */
// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import {randomElementFromArray} from '../core/Utilities';
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import ContentData from '../core/ContentData';
import CoreStyles from '../core/Styles';
import {TitleText, LabelSmallText} from '../core/Type';
// Layouts
import {Grid, OneColumnLayout} from '../layouts/Grid';


export default class TopicHeader extends React.Component {
    static Variant = {
        Centered: "centered", // Default variant
        Stretched: "stretched",
    };
    render() {
        const {variant} = this.props;
        const columnVariant = variant === TopicHeader.Variant.Stretched
            ? Grid.Variant.Stretched
            : Grid.Variant.Centered;

        return (
            <div
                className={css(
                    styles.container,
                    CoreStyles.hairlineStrokeBottom,
                    ...this.props.styles,
                )}
            >
                <OneColumnLayout
                    variant={columnVariant}
                    column1={<div>
                        <LabelSmallText styles={[styles.textStyles]}>
                            {randomElementFromArray(ContentData.Subjects)}
                        </LabelSmallText>
                        <TitleText styles={[styles.textStyles]}>
                            {randomElementFromArray(ContentData.Units)}
                        </TitleText>
                    </div>}
                />
            </div>
        );
    }
}
TopicHeader.defaultProps = {
    variant: TopicHeader.Variant.Centered,
    styles: [],
};


const styles = createExpandableMediaQueryStylesheet({
    container: {
        width: "100%",
        paddingTop: CoreMetrics.ElementSpacing.XLarge(),
        paddingBottom: CoreMetrics.ElementSpacing.XLarge(),
        display: "flex",
        flexDirection: "column",
        alignContent: "flex-start",
        justifyContent: "center",
        backgroundColor: CoreMetrics.Color.Debug,
        color: CoreMetrics.Color.Neutral.White,
    },
    textStyles: {
        color: CoreMetrics.Color.Neutral.White,
    },
});



// WEBPACK FOOTER //
// ./src/modules/TopicHeader.jsx